import React from 'react';
import PropTypes from 'prop-types';
import Wrapper from './Wrapper';
import Header from './Header';
import Channels from './Channels';
import DirectMessages from './DirectMessages';
import Broadcasts from './Broadcasts';

const ChannelSidebar = ({
  channels,
  activeChannelId,
  selectChannel,
  centerName,
  employeeName,
  toggleNewChannelModal,
  toggleDirectMessageModal,
  toggleCenterChannelsModal,
  toggleNewBroadcastModal,
  channelsWithNewMessages,
  isManager,
  ...props
}) => {
  const isBroadcastChannel = channel => Boolean(channel.broadcastType) && Boolean(channel.broadcastTypeId);

  const publicPrivateChannels = channels.filter(channel => !channel.directMessage && !isBroadcastChannel(channel));
  const directMessages = channels.filter(channel => channel.directMessage);
  const broadcasts = channels.filter(channel => isBroadcastChannel(channel));

  return (
    <Wrapper>
      <Header
        username={employeeName}
        isManager={isManager}
      />
      <Broadcasts
        createNewBroadcast={toggleNewBroadcastModal}
        broadcasts={broadcasts}
        activeChannelId={activeChannelId}
        onChannelSelect={selectChannel}
        channelsWithNewMessages={channelsWithNewMessages}
      />
      <Channels
        activeChannelId={activeChannelId}
        channels={publicPrivateChannels}
        onChannelSelect={selectChannel}
        createNewChannel={toggleNewChannelModal}
        channelsWithNewMessages={channelsWithNewMessages}
        showChannelsAtCenter={toggleCenterChannelsModal}
      />
      <DirectMessages
        activeChannelId={activeChannelId}
        dms={directMessages}
        onMessageSelect={selectChannel}
        openDirectMessageModal={() => toggleDirectMessageModal(directMessages)}
        channelsWithNewMessages={channelsWithNewMessages}
      />
    </Wrapper>
  );
};

ChannelSidebar.propTypes = {
  channels: PropTypes.array,
  activeChannelId: PropTypes.string,
  selectChannel: PropTypes.func,
  centerName: PropTypes.string,
  employeeName: PropTypes.string,
  toggleNewChannelModal: PropTypes.func,
  toggleDirectMessageModal: PropTypes.func,
  toggleNewBroadcastModal: PropTypes.func,
  toggleCenterChannelsModal: PropTypes.func,
  channelsWithNewMessages: PropTypes.shape({
    [PropTypes.number]: PropTypes.bool
  }),
  isManager: PropTypes.bool
};

export default ChannelSidebar;
